<!-- Floating chatbot trigger button - AI Style -->
<button class="chatbot-trigger btn rounded-circle shadow-lg" (click)="toggleChatbot()" [@bounce]="bounceState"
  [attr.aria-label]="'chatbot_open' | translate">
  <i class="bi" [ngClass]="isOpen ? 'bi-chevron-down' : 'bi-chat-dots-fill'"></i>
</button>

<!-- Chatbot window -->
<div class="chatbot-window card shadow-lg" *ngIf="isOpen" [@slideUp] [class.expanded]="isExpanded">

  <!-- HOME VIEW -->
  <div class="chatbot-view" *ngIf="currentView === ChatView.HOME" [@fadeTransition]>
    <!-- Header -->
    <div class="chatbot-header">
      <div class="header-content">
        <div class="header-icon">
          <img src="assets/img/logo256x256.png" alt="Naaora Logo" class="naaora-logo">
        </div>
        <div class="header-info">
          <h5 class="mb-0">{{ 'chatbot_greeting' | translate }}</h5>
          <p class="mb-0 small">{{ 'chatbot_subtitle' | translate }}</p>
        </div>
      </div>
      <button class="btn-close-ai" (click)="closeChatbot()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Home Content -->
    <div class="chatbot-content">
      <div class="welcome-section">
        <p class="welcome-text">{{ 'chatbot_welcome_text' | translate }}</p>

        <!-- Quick action buttons -->
        <div class="quick-actions" [@scaleIn]>
          <button class="quick-action-btn" *ngFor="let option of quickReplyOptions; trackBy: trackByArticleId"
            (click)="handleQuickReply(option)" [@fadeIn]>
            <i [class]="option.icon + ' text-ai'"></i>
            <span>{{ option.label | translate }}</span>
            <i class="bi bi-chevron-right "></i>
          </button>
        </div>
      </div>

      <!-- Main navigation options -->
      <div class="nav-options">
        <!-- Search box -->
        <div class="search-box" (click)="navigateToHelpFromSearch()">
          <i class="bi bi-search text-ai"></i>
          <span class="search-placeholder">{{ 'chatbot_search_help' | translate }}</span>
          <i class="bi bi-chevron-right text-ai"></i>
        </div>

        <!-- Popular articles -->
        <h6 class="popular-articles-title">{{ 'chatbot_popular_questions' | translate }}</h6>
        <div class="article-item" *ngFor="let article of getPopularArticles() | slice:0:5; trackBy: trackByArticleId"
          (click)="openArticle(article)" [@fadeIn]>
          <i [class]="article.icon || 'bi bi-file-text'" class="text-ai"></i>
          <div class="article-text">
            <h6 class="mb-0">{{ article.title }}</h6>
            <small>{{ article.description }}</small>
          </div>
          <i class="bi bi-chevron-right text-ai"></i>
        </div>
      </div>
    </div>

    <!-- BOTTOM NAVIGATION FOR HOME VIEW -->
    <div class="chatbot-bottom-nav">
      <button class="nav-btn active">
        <i class="bi bi-house-fill"></i>
        <span>{{ 'chatbot_home' | translate }}</span>
      </button>
      <button class="nav-btn" (click)="navigateToView(ChatView.CONVERSATIONS_LIST)">
        <i class="bi bi-chat-left-fill"></i>
        <span>{{ 'chatbot_conversations' | translate }}</span>
      </button>
      <button class="nav-btn" (click)="navigateToView(ChatView.HELP)">
        <i class="bi bi-question-circle-fill"></i>
        <span>{{ 'chatbot_help' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- CONVERSATION VIEW -->
  <div class="chatbot-view" *ngIf="currentView === ChatView.CONVERSATION" [@fadeTransition]>
    <!-- Header -->
    <div class="chatbot-header">
      <button class="btn btn-link header-back-btn p-0 me-2" (click)="goBack()" [attr.aria-label]=" 'Back' | translate ">
        <i class="bi bi-chevron-left text-ai"></i>
      </button>
      <div class="header-info flex-grow-1">
        <h6 class="mb-0">{{ 'chatbot_assistant' | translate }}</h6>
        <small>
          <span class="online-indicator"></span>
          {{ 'chatbot_online' | translate }}
        </small>
      </div>
      <button class="btn btn-link p-0 me-2 expand-btn" (click)="toggleExpand()" [attr.aria-label]="'Toggle expand'">
        <i class="bi text-ai" [ngClass]="isExpanded ? 'bi-arrows-angle-contract' : 'bi-arrows-angle-expand'"></i>
      </button>
      <button class="btn-close-ai" (click)="closeChatbot()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Messages Container -->
    <div class="chatbot-content chatbot-content--no-scroll">
      <!-- Messages -->
      <div class="chatbot-messages" (scroll)="onMessagesScroll($event)">
        <!-- Loading indicator for older messages -->
        <div class="loading-indicator-top" *ngIf="isLoadingMessages" [@fadeIn]>
          <div class="spinner-border spinner-border-sm text-ai" role="status">
            <span class="sr-only">{{ 'chatbot_loading' | translate }}</span>
          </div>
          <span class="ms-2">{{ 'chatbot_loading_messages' | translate }}</span>
        </div>
        <div *ngFor="let message of messages; trackBy: trackByMessageId" class="message-wrapper"
          [ngClass]="message.isUser ? 'user-message' : 'bot-message'"
          [class.expanded]="expandedMessageId === message.id" (click)="toggleMessageExpand(message.id)" [@fadeIn]>
          <div class="message-avatar" *ngIf="!message.isUser">
            <i class="bi bi-robot"></i>
            <span class="avatar-online-indicator"></span>
          </div>
          <div class="message-content">
            <div class="message-meta" *ngIf="!message.isUser">
              <span class="assistant-label">{{ 'chatbot_assistant' | translate }}</span>
            </div>
            <div class="message-bubble" *ngIf="message.isUser">
              {{ message.text }}
            </div>
            <div class="message-bubble markdown-content" *ngIf="!message.isUser" [innerHTML]="message.text | markdown">
            </div>

            <span class="message-time" *ngIf="expandedMessageId === message.id && message.isUser" [@fadeInOut]>
              {{ getRelativeTime(message.timestamp) }}
            </span>
            <span class="message-time" *ngIf="expandedMessageId === message.id && !message.isUser" [@fadeInOut]>
              {{ getRelativeTime(message.timestamp) }}
            </span>
          </div>
          <div class="message-avatar" *ngIf="message.isUser">
            <i class="bi bi-person-circle"></i>
          </div>
        </div>

        <!-- Initial typing indicator (only for new conversations) -->
        <div class="message-wrapper bot-message"
          *ngIf="isInitialTyping && currentView === ChatView.CONVERSATION && messages.length === 0" [@fadeIn]>
          <div class="message-avatar">
            <i class="bi bi-robot"></i>
            <span class="avatar-online-indicator"></span>
          </div>
          <div class="message-content">
            <div class="message-meta">
              <span class="assistant-label">{{ 'chatbot_assistant' | translate }}</span>
            </div>
            <div class="typing-indicator">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

        <!-- Typing indicator  -->
        <div class="message-wrapper bot-message" *ngIf="isTyping && !isInitialTyping" [@fadeIn]>
          <div class="message-avatar">
            <i class="bi bi-robot"></i>
          </div>
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <!-- Usage Limit Alert -->
    <div class="usage-limit-alert" *ngIf="isUsageLimitExceeded" [@fadeIn]>
      <div class="alert-content">
        <div class="alert-icon">
          <i class="bi bi-exclamation-circle"></i>
        </div>
        <div class="alert-text">
          <h6 class="alert-title">{{ 'chatbot_usage_limit_title' | translate }}</h6>
          <p class="alert-message">{{ 'chatbot_usage_limit_message' | translate }}</p>
          <small class="alert-detail" *ngIf="usageLimitDetail">{{ usageLimitDetail }}</small>
        </div>
        <button class="btn-dismiss" (click)="dismissUsageLimitAlert()" [attr.aria-label]="'close' | translate">
          <i class="bi bi-x"></i>
        </button>
      </div>
    </div>

    <!-- Navigation Route Chips - Above input, from last bot message -->
    <div class="chatbot-navigation-routes" *ngIf="currentNavigationRoutes.length > 0" [@fadeIn]>
      <ng-container *ngFor="let route of currentNavigationRoutes; trackBy: trackByRouteUri">
        <button class="route-chip" *ngIf="canResolveRoute(route)" (click)="navigateToRoute(route)">
          <i class="bi bi-box-arrow-up-right"></i>
          <span>{{ route.label }}</span>
        </button>
      </ng-container>
    </div>

    <!-- Input -->
    <div class="chatbot-input">
      <input type="text" class="form-control" [(ngModel)]="userInput" (keydown)="onInputKeydown($event)"
        [placeholder]="'chatbot_placeholder' | translate" [disabled]="isTyping || isUsageLimitExceeded">
      <button class="btn btn-ai" (click)="sendMessage()"
        [disabled]="!userInput.trim() || isTyping || isUsageLimitExceeded">
        <i class="bi bi-send-fill"></i>
      </button>
    </div>

    <!-- BOTTOM NAVIGATION FOR CONVERSATION VIEW -->
    <div class="chatbot-bottom-nav">
      <button class="nav-btn" (click)="navigateToView(ChatView.HOME)">
        <i class="bi bi-house-fill"></i>
        <span>{{ 'chatbot_home' | translate }}</span>
      </button>
      <button class="nav-btn active" (click)="navigateToView(ChatView.CONVERSATIONS_LIST)">
        <i class="bi bi-chat-left-fill"></i>
        <span>{{ 'chatbot_conversations' | translate }}</span>
      </button>
      <button class="nav-btn" (click)="navigateToView(ChatView.HELP)">
        <i class="bi bi-question-circle-fill"></i>
        <span>{{ 'chatbot_help' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- CONVERSATIONS LIST VIEW -->
  <div class="chatbot-view" *ngIf="currentView === ChatView.CONVERSATIONS_LIST" [@fadeTransition]>
    <!-- Header -->
    <div class="chatbot-header">
      <div class="header-content">
        <div class="header-icon">
          <i class="bi bi-chat-left-text text-ai"></i>
        </div>
        <div class="header-info">
          <h5 class="mb-0">{{ 'chatbot_conversations' | translate }}</h5>
        </div>
      </div>
      <button class="btn-close-ai" (click)="closeChatbot()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Content Area -->
    <div class="chatbot-content">
      <!-- Loading indicator for initial load -->
      <div class="initial-loading-state" *ngIf="isLoadingConversations && conversations.length === 0" [@fadeIn]>
        <div class="spinner-border text-ai" role="status">
          <span class="sr-only">{{ 'loading' | translate }}</span>
        </div>
        <p class="loading-text mt-2">{{ 'loading' | translate }}...</p>
      </div>

      <!-- Empty state -->
      <div class="empty-state" *ngIf="!isLoadingConversations && conversations.length === 0">
        <i class="bi bi-chat-left-text-fill"></i>
        <p>{{ 'chatbot_no_conversations' | translate }}</p>
        <button class="btn btn-ai" (click)="startNewConversation()">
          {{ 'chatbot_start_conversation' | translate }}
        </button>
      </div>

      <!-- Conversations list -->
      <div class="conversations-list-container" *ngIf="conversations.length > 0"
        (scroll)="onConversationsScroll($event)">
        <div class="conversations-list">
          <div class="conversation-item" *ngFor="let conversation of conversations; trackBy: trackByConversationId"
            (click)="loadConversation(conversation)" [@slideOutUp]>
            <div class="conversation-icon">
              <i class="bi bi-chat-left-text"></i>
            </div>
            <div class="conversation-info">
              <h6 class="mb-0">{{ conversation.title }}</h6>
              <p class="mb-0 small">{{ conversation.lastMessage }}</p>
              <small>{{ conversation.timestamp | date:'short' }}</small>
            </div>
            <button class="btn btn-link text-danger p-0" (click)="deleteConversation(conversation.id, $event)"
              [attr.aria-label]="'chatbot_delete_conversation' | translate">
              <i class="bi bi-trash"></i>
            </button>
          </div>

          <!-- Loading indicator for pagination -->
          <div class="loading-indicator-bottom" *ngIf="isLoadingConversations && conversations.length > 0" [@fadeIn]>
            <div class="spinner-border spinner-border-sm text-ai" role="status">
              <span class="sr-only">{{ 'loading' | translate }}</span>
            </div>
            <span class="ms-2">{{ 'loading' | translate }}...</span>
          </div>
        </div>
      </div>

      <!-- New conversation button at bottom -->
      <div class="new-conversation-button-wrapper p-3" *ngIf="conversations.length > 0">
        <button class="btn btn-ai-outline w-100 btn-new-conversation" (click)="startNewConversation()">
          <i class="bi bi-pencil-square me-2"></i>
          {{ 'chatbot_new_conversation' | translate }}
        </button>
      </div>
    </div>

    <!-- BOTTOM NAVIGATION FOR CONVERSATIONS VIEW -->
    <div class="chatbot-bottom-nav">
      <button class="nav-btn" (click)="navigateToView(ChatView.HOME)">
        <i class="bi bi-house-fill"></i>
        <span>{{ 'chatbot_home' | translate }}</span>
      </button>
      <button class="nav-btn active">
        <i class="bi bi-chat-left-fill"></i>
        <span>{{ 'chatbot_conversations' | translate }}</span>
      </button>
      <button class="nav-btn" (click)="navigateToView(ChatView.HELP)">
        <i class="bi bi-question-circle-fill"></i>
        <span>{{ 'chatbot_help' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- HELP VIEW -->
  <div class="chatbot-view" *ngIf="currentView === ChatView.HELP" [@fadeTransition]>
    <!-- Header -->
    <div class="chatbot-header">
      <div class="header-content">
        <div class="header-icon">
          <i class="bi bi-question-circle text-ai"></i>
        </div>
        <div class="header-info">
          <h5 class="mb-0">{{ 'chatbot_help_center' | translate }}</h5>
        </div>
      </div>
      <button class="btn-close-ai" (click)="closeChatbot()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Search -->
    <div class="help-search">
      <div class="input-group mb-0">
        <span class="input-group-text bg-transparent border-0">
          <i class="bi bi-search"></i>
        </span>
        <input #searchInput type="text" class="form-control border-0" [(ngModel)]="searchQuery" (input)="searchHelp()"
          [placeholder]="'chatbot_search_help' | translate">
      </div>
    </div>

    <!-- Content -->
    <div class="chatbot-content">
      <!-- Search results -->
      <div class="search-results" *ngIf="searchQuery.trim().length > 0">
        <div *ngIf="isSearching" class="text-center py-4">
          <div class="spinner-border text-ai" role="status">
            <span class="sr-only">{{ 'loading' | translate }}</span>
          </div>
        </div>

        <div *ngIf="!isSearching && searchResults.length > 0">
          <div class="help-article-item" *ngFor="let article of searchResults; trackBy: trackByArticleId"
            (click)="openArticle(article)" [@fadeIn]>
            <i class="bi bi-file-text text-ai"></i>
            <div class="article-info">
              <h6 class="mb-0">{{ article.title }}</h6>
              <small>{{ article.description }}</small>
            </div>
            <i class="bi bi-chevron-right text-muted"></i>
          </div>
        </div>

        <div *ngIf="!isSearching && searchResults.length === 0" class="empty-state">
          <i class="bi bi-search text-muted"></i>
          <p>{{ 'chatbot_no_results' | translate }}</p>
        </div>
      </div>

      <!-- Help collections -->
      <div class="help-collections" *ngIf="searchQuery.trim().length === 0">
        <h6 class="collections-title">{{ 'chatbot_collections' | translate }}</h6>

        <!-- Loading state -->
        <div class="initial-loading-state" *ngIf="isLoadingHelpCollections" [@fadeIn]>
          <div class="spinner-border text-ai" role="status">
            <span class="sr-only">{{ 'loading' | translate }}</span>
          </div>
          <p class="loading-text mt-2">{{ 'loading' | translate }}...</p>
        </div>

        <!-- Empty state -->
        <div class="empty-state" *ngIf="!isLoadingHelpCollections && helpCollections.length === 0">
          <i class="bi bi-folder-x text-muted"></i>
          <p>{{ 'chatbot_no_collections' | translate }}</p>
        </div>

        <!-- Collections list -->
        <ng-container *ngIf="!isLoadingHelpCollections && helpCollections.length > 0">
          <div class="collection-card" *ngFor="let collection of helpCollections; trackBy: trackByCollectionId"
            [@fadeIn]>
            <div class="collection-header" (click)="collection['expanded'] = !collection['expanded']">
              <i class="collection-icon text-ai" [ngClass]="collection.icon || 'bi bi-folder'"></i>
              <div class="collection-info">
                <h6 class="mb-0">{{ collection.title }}</h6>
                <p class="mb-0 small">{{ collection.description }}</p>
                <small class="text-ai">{{ collection.article_count || collection.articles?.length || 0 }} {{
                  'chatbot_articles' | translate }}</small>
              </div>
              <i class="bi" [ngClass]="collection['expanded'] ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>

            <div class="collection-articles" *ngIf="collection['expanded']" [@slideDown]>
              <div class="help-article-item" *ngFor="let article of collection.articles; trackBy: trackByArticleId"
                (click)="openArticle(article)" [@fadeIn]>
                <i class="text-ai" [ngClass]="article.icon || 'bi bi-file-text'"></i>
                <div class="article-info">
                  <h6 class="mb-0">{{ article.title }}</h6>
                  <small>{{ article.description }}</small>
                </div>
                <i class="bi bi-chevron-right"></i>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- BOTTOM NAVIGATION FOR HELP VIEW -->
    <div class="chatbot-bottom-nav">
      <button class="nav-btn" (click)="navigateToView(ChatView.HOME)">
        <i class="bi bi-house-fill"></i>
        <span>{{ 'chatbot_home' | translate }}</span>
      </button>
      <button class="nav-btn" (click)="navigateToView(ChatView.CONVERSATIONS_LIST)">
        <i class="bi bi-chat-left-fill"></i>
        <span>{{ 'chatbot_conversations' | translate }}</span>
      </button>
      <button class="nav-btn active">
        <i class="bi bi-question-circle-fill"></i>
        <span>{{ 'chatbot_help' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- ARTICLE VIEW -->
  <div class="chatbot-view" *ngIf="currentView === ChatView.ARTICLE && selectedArticle" [@fadeTransition]>
    <!-- Header -->
    <div class="chatbot-header">
      <button class="btn btn-link header-back-btn p-0 me-2" (click)="goBack()" [attr.aria-label]=" 'Back' | translate ">
        <i class="bi bi-chevron-left text-ai"></i>
      </button>
      <h6 class="mb-0 flex-grow-1 text-truncate">{{ selectedArticle.title }}</h6>
      <button class="btn btn-link p-0 me-2 expand-btn" (click)="toggleExpand()" [attr.aria-label]="'Toggle expand'">
        <i class="bi text-ai" [ngClass]="isExpanded ? 'bi-arrows-angle-contract' : 'bi-arrows-angle-expand'"></i>
      </button>
      <button class="btn-close-ai" (click)="closeChatbot()" aria-label="Close">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <!-- Article Content Area -->
    <div class="chatbot-content article-content">
      <!-- Loading state -->
      <div *ngIf="isLoadingArticle" class="loading-state text-center py-4">
        <div class="spinner-border text-ai" role="status">
          <span class="sr-only">{{ 'loading' | translate }}</span>
        </div>
        <p class="mt-2 small text-muted">{{ 'loading' | translate }}...</p>
      </div>

      <!-- Article body -->
      <ng-container *ngIf="!isLoadingArticle">
        <!-- HTML Content -->
        <div *ngIf="selectedArticle.multimedia?.type === 'HTML' && safeHtmlUrl" class="article-body html-content">
          <iframe [src]="safeHtmlUrl" class="html-viewer" width="100%" height="100%" frameborder="0"></iframe>
        </div>

        <!-- MARKDOWN Content -->
        <div *ngIf="selectedArticle.multimedia?.type === 'MARKDOWN' && articleMarkdownContent"
          class="article-body markdown-content" [innerHTML]="articleMarkdownContent | markdown">
        </div>

        <!-- PDF Content -->
        <div *ngIf="selectedArticle.multimedia?.type === 'PDF' && safePdfUrl" class="article-body pdf-content">
          <iframe [src]="safePdfUrl" class="pdf-viewer" width="100%" height="100%" frameborder="0"></iframe>
          <a [href]="selectedArticle.multimedia.url" target="_blank" rel="noopener"
            class="btn btn-ai-outline btn-sm mt-2 w-100">
            <i class="bi bi-download me-1"></i> {{ 'download_pdf' | translate }}
          </a>
        </div>

        <!-- Fallback -->
        <div *ngIf="!selectedArticle.multimedia" class="article-body no-content">
          <div class="article-header mb-3">
            <i [class]="selectedArticle.icon || 'bi bi-file-text'" class="article-icon text-ai"></i>
            <h5 class="article-title">{{ selectedArticle.title }}</h5>
          </div>
          <p class="article-description">{{ selectedArticle.description }}</p>
        </div>
      </ng-container>

      <!-- Feedback -->
      <div class="article-footer" *ngIf="!isLoadingArticle">
        <p class="small mb-2">{{ 'chatbot_was_helpful' | translate }}</p>
        <div class="btn-group">
          <button class="btn btn-sm btn-ai-outline">
            <i class="bi bi-hand-thumbs-up"></i> {{ 'yes' | translate }}
          </button>
          <button class="btn btn-sm btn-ai-outline ms-2">
            <i class="bi bi-hand-thumbs-down"></i> {{ 'no' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- BOTTOM NAVIGATION FOR ARTICLE VIEW -->
    <div class="chatbot-bottom-nav">
      <button class="nav-btn" (click)="navigateToView(ChatView.HOME)">
        <i class="bi bi-house-fill"></i>
        <span>{{ 'chatbot_home' | translate }}</span>
      </button>
      <button class="nav-btn" (click)="navigateToView(ChatView.CONVERSATIONS_LIST)">
        <i class="bi bi-chat-left-fill"></i>
        <span>{{ 'chatbot_conversations' | translate }}</span>
      </button>
      <button class="nav-btn active">
        <i class="bi bi-question-circle-fill"></i>
        <span>{{ 'chatbot_help' | translate }}</span>
      </button>
    </div>
  </div>

</div>